// Cart Drawer JavaScript - Event delegation for dynamic content

// Only initialize once
let cartDrawerEventsInitialized = false;

function initCartDrawerEvents() {
  // Prevent duplicate initialization
  if (cartDrawerEventsInitialized) return;
  
  // Use event delegation for dynamic content
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  if (!cartDrawer) return;

  // Mark as initialized
  cartDrawerEventsInitialized = true;

  // Single click handler for all cart drawer interactions
  // Note: We don't handle close buttons here - they're handled in global.js
  cartDrawer.addEventListener('click', async function(e) {
    // Handle quantity change buttons
    const quantityBtn = e.target.closest('[data-quantity-change]');
    if (quantityBtn) {
      e.preventDefault();
      e.stopPropagation();
      await handleQuantityChange(quantityBtn);
      return;
    }

    // Handle remove item buttons
    const removeBtn = e.target.closest('[data-remove-item]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      await handleRemoveItem(removeBtn);
      return;
    }
    
    // Don't prevent default for close buttons - let global.js handle them
  });
}

// Handle quantity change
async function handleQuantityChange(btn) {
  const key = btn.dataset.quantityChange;
  const change = parseInt(btn.dataset.change);
  const quantityContainer = btn.closest('.cart-drawer__quantity');
  const quantitySpan = quantityContainer ? quantityContainer.querySelector('span') : null;
  
  if (!quantitySpan) {
    console.error('Quantity span not found');
    return;
  }
  
  const currentQty = parseInt(quantitySpan.textContent) || 0;
  const newQty = Math.max(0, currentQty + change);

  // Show loading state
  btn.disabled = true;
  btn.style.opacity = '0.5';

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: newQty
      })
    });

    if (response.ok) {
      const cart = await response.json();
      
      if (newQty === 0) {
        // Remove item from DOM
        const item = btn.closest('[data-cart-item]');
        if (item) {
          item.style.transition = 'opacity 0.3s, transform 0.3s';
          item.style.opacity = '0';
          item.style.transform = 'translateX(20px)';
          setTimeout(() => {
            item.remove();
            // Check if cart is empty after removal
            if (cart.item_count === 0) {
              showEmptyCart();
            }
          }, 300);
        }
      } else {
        // Update quantity display
        quantitySpan.textContent = newQty;
        
        // Update item price
        const item = btn.closest('[data-cart-item]');
        if (item) {
          const priceEl = item.querySelector('.cart-drawer__item-price');
          if (priceEl) {
            // Find the matching item in cart response
            const cartItem = cart.items.find(i => i.key === key);
            if (cartItem) {
              priceEl.textContent = formatMoney(cartItem.line_price);
            }
          }
        }
      }
      
      // Update cart count and total
      updateCartCounts(cart.item_count);
      updateCartTotal(cart.total_price);
      
    } else {
      console.error('Failed to update cart quantity');
      alert('Failed to update quantity. Please try again.');
    }
  } catch (error) {
    console.error('Error updating cart:', error);
    alert('Error updating cart. Please try again.');
  } finally {
    // Restore button state
    btn.disabled = false;
    btn.style.opacity = '1';
  }
}

// Handle remove item
async function handleRemoveItem(btn) {
  const key = btn.dataset.removeItem;
  const item = btn.closest('[data-cart-item]');

  // Show loading state
  btn.disabled = true;
  if (item) {
    item.style.opacity = '0.5';
  }

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    });

    if (response.ok) {
      const cart = await response.json();
      
      // Remove item from DOM with animation
      if (item) {
        item.style.transition = 'opacity 0.3s, transform 0.3s';
        item.style.opacity = '0';
        item.style.transform = 'translateX(20px)';
        setTimeout(() => {
          item.remove();
          // Check if cart is empty after removal
          if (cart.item_count === 0) {
            showEmptyCart();
          }
        }, 300);
      }
      
      // Update cart count and total
      updateCartCounts(cart.item_count);
      updateCartTotal(cart.total_price);
      
    } else {
      console.error('Failed to remove item from cart');
      alert('Failed to remove item. Please try again.');
      // Restore item opacity
      if (item) {
        item.style.opacity = '1';
      }
    }
  } catch (error) {
    console.error('Error removing item:', error);
    alert('Error removing item. Please try again.');
    // Restore item opacity
    if (item) {
      item.style.opacity = '1';
    }
  } finally {
    btn.disabled = false;
  }
}

// Show empty cart state
function showEmptyCart() {
  const cartBody = document.querySelector('[data-cart-drawer-body]');
  const cartFooter = document.querySelector('.cart-drawer__footer');
  
  if (cartBody) {
    cartBody.innerHTML = `
      <div class="cart-drawer__empty">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p>Your cart is empty</p>
      </div>
    `;
  }
  
  if (cartFooter) {
    cartFooter.style.display = 'none';
  }
}

// Update cart counts in header
function updateCartCounts(count) {
  const cartCounts = document.querySelectorAll('[data-cart-count]');
  cartCounts.forEach(countEl => {
    countEl.textContent = count;
    if (count > 0) {
      countEl.classList.remove('hidden');
      countEl.style.display = '';
    } else {
      countEl.classList.add('hidden');
      countEl.style.display = 'none';
    }
  });
}

// Update cart total
function updateCartTotal(totalPrice) {
  const totalEls = document.querySelectorAll('[data-cart-total]');
  totalEls.forEach(totalEl => {
    totalEl.textContent = formatMoney(totalPrice);
  });
}

// Format money using Shopify's money format with currency
function formatMoney(cents) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  // Use money_with_currency format to show currency code (e.g., HK$, USD, etc.)
  const formatString = window.moneyWithCurrencyFormat || window.moneyFormat || '${{amount}} USD';
  
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderRegex, value);
}

// Make initCartDrawerEvents available globally for re-initialization
window.initCartDrawerEvents = initCartDrawerEvents;
